import { Select, Space, Card } from "antd";
import React, { useEffect } from "react";
import PreventivoGuestRow from "./PreventivoGuestRow";
import PreventivoGuestRowProduct from "./PreventivoGuestRowProduct";
import styled from "styled-components";
const { Option } = Select;

const Tab = styled.button`
  padding: 16px 20px;
  font-size: 22px;
  background: #f5f5f5;
  border: 2px solid transparent;
  border-radius: 9999px;
  cursor: pointer;
  transition: all 0.2s ease;

  &.active {
    background: white;
    border: 3px solid blue;
    font-weight: bold;
  }
`;

function PreventivoGuestSelectOffer({ preventivo, setPreventivo }) {
    return (<>
            {[...new Set(preventivo.rows?.map(row => row.num_offer != "aaaa"))].map((_, __index0) => /*ho reso questo map inutile*/
                <ul role="list" className="-my-6 divide-y divide-gray-200">
<span>
                            {[...new Set(preventivo.rows?.sort((a,b) => a.num_offer - b.num_offer).map(row => row.num_offer))].map((offerId, index) => (
                                <Tab
                                    className={preventivo.selectedOffer == index ? "active" : ""}
                                    onClick={() => {setPreventivo(prev => ({ ...preventivo, selectedOffer: index })) }}
                                >
                                    <span>{"Proposta " + (index + 1)}</span>

                                </Tab>
                            ))}

                    </span>


                    

                </ul>
            )}

        </>
    );
}
export default PreventivoGuestSelectOffer;
